export default __webpack_public_path__ + "static/media/bi.779f1f4a.png";